//Set Gap
export function SetGap(GapElement, FooterElement) {
    var $GapElement = $(GapElement);
    var height = $(FooterElement).outerHeight(true);

    $GapElement.height(height);
    return;
}